export const TOGGLE_HEADER_BAR = 'TOGGLE_HEADER_BAR';
export const HIDE_HEADER_BAR = 'HIDE_HEADER_BAR';
export const SHOW_HEADER_BAR = 'SHOW_HEADER_BAR';

export const toggleHeaderBar = () => ({ type: TOGGLE_HEADER_BAR });
export const hideHeaderBar = () => ({ type: HIDE_HEADER_BAR });
export const showHeaderBar = () => ({ type: SHOW_HEADER_BAR });
